// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"ec57ab36","885":"dd5e2a8f"}[chunkId] + ".chunk.js";
};